import Permissions from '../components/Permissions';
import Pageheader from '../utils/headerHelment';

const PermissionsView = () => {
    return (
        <>
            <Pageheader title="LENS - Permissions" />
            <Permissions />
        </>
    );
};

export default PermissionsView;
